import { EVENT_TYPES } from 'src/api/getEvents/types';

export enum ScheduleStatus {
  SCHEDULED = 'SCHEDULED',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
  CANCELLED = 'CANCELLED',
  SENT = 'SENT',
  // A product sync has since updated/removed an item this (menu) schedule's
  // snapshot depends on - it needs to be deleted and recreated.
  CAUTION = 'CAUTION',
}

export type ScheduleEventType =
  | typeof EVENT_TYPES.PUBLISH_PRODUCT
  | typeof EVENT_TYPES.PUBLISH_PRICING
  | typeof EVENT_TYPES.PUBLISH_MENU;

export enum ValidationStatus {
  NOT_VALIDATED = 'NOT_VALIDATED',
  VALIDATING = 'VALIDATING',
  VALIDATED = 'VALIDATED',
  VALIDATION_FAILED = 'VALIDATION_FAILED',
}

export interface IScheduleVenue {
  venue_id: string;
  name: string;
}

export interface IExcludedScheduleItem {
  item_id: string;
  name: string;
}

export interface ISchedule {
  schedule_id: string;
  schedule_name: string;
  scheduled_for: string;
  status: ScheduleStatus;
  event_id: string;
  event_type: ScheduleEventType;
  price_scheme: { price_scheme_id: string; name: string } | null;
  validation: {
    status: ValidationStatus;
    validated_at: string | null;
    report_id: string | null;
  };
  venues: IScheduleVenue[];
  external_systems: { external_system_id: string; name: string }[];
  create_date: string;
  update_date: string;
  excluded_items?: IExcludedScheduleItem[];
}

export interface IGetSchedulesResponse {
  type: 'schedules';
  data: ISchedule[];
  paging: {
    next: string | null;
  };
}
